// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const billingDryRunLineDto = {
    kind: 'kind',
    userName: 'userName',
    functionName: 'functionName',
    days: 'days',
    blocks: 'blocks',
    credits: 'credits',
    note: 'note',
} as const;

export type TBillingDryRunLineDto = (typeof billingDryRunLineDto)[keyof typeof billingDryRunLineDto];

export interface IBillingDryRunLineDto {
    [billingDryRunLineDto.kind]: string | null;
    [billingDryRunLineDto.userName]: string | null;
    [billingDryRunLineDto.functionName]: string | null;
    [billingDryRunLineDto.days]: number | null;
    [billingDryRunLineDto.blocks]: number | null;
    [billingDryRunLineDto.credits]: number | null;
    [billingDryRunLineDto.note]: string | null;
}

export class BillingDryRunLineDto
    implements IBillingDryRunLineDto
{
    [billingDryRunLineDto.kind]: string | null = null;
    [billingDryRunLineDto.userName]: string | null = null;
    [billingDryRunLineDto.functionName]: string | null = null;
    [billingDryRunLineDto.days]: number | null = null;
    [billingDryRunLineDto.blocks]: number | null = null;
    [billingDryRunLineDto.credits]: number | null = null;
    [billingDryRunLineDto.note]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IBillingDryRunLineData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[billingDryRunLineDto.guid] = modelData[billingdryrunlineData.guid];
    }

    static create(modelData?: any | null): IBillingDryRunLineDto | null {
        return modelData ? new BillingDryRunLineDto(modelData) : null;
    }
}
